// Productsview.js - Updated
import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import '../Css/Productsview.css'
import Topnavbar from '../Header-pages/Topnavbar'
import Navbar from '../Header-pages/Navbar'
import Footer from '../Header-pages/Footer'
import { API_URL } from '../utils/Function'

export default function Productsview() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await fetch(`${API_URL}/product.php/get`);
      const data = await response.json();
      
      if (data.success) {
        setProducts(data.products || []);
      } else {
        setError(data.error || 'Failed to fetch products');
      }
    } catch (err) {
      setError('Network error: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleViewMore = (product) => {
    scrollToTop();
    setTimeout(() => {
      navigate(`/product/${product.slug || product.id}`, { state: { product } });
    }, 100);
  };

  // Handle home navigation with scroll to top
  const handleHomeNavigation = () => {
    scrollToTop();
    setTimeout(() => {
      navigate('/');
    }, 100);
  };

  return (
    <>
      <Topnavbar/>
      <Navbar/>
      
      <div className='productsview-page'>
        {/* Hero Section with Breadcrumbs */}
        <div className='productsview-hero-section'>
          <img 
            src='/images/Productview.jpg' 
            alt='Products' 
            className='productsview-hero-image'
          />
          <div className='productsview-hero-overlay'>
            {/* Breadcrumbs inside hero */}
            <div className='productsview-hero-breadcrumbs'>
              <a onClick={handleHomeNavigation} style={{cursor:'pointer'}}>Home</a>
              <span className='productsview-breadcrumb-separator'>/</span>
              <span className='productsview-breadcrumb-current'style={{color:'#fff', cursor:'pointer'}}>Products</span>
            </div>
            
            <div className='productsview-hero-content'>
              <h1>Products</h1>
              <p>Powerful, reliable, and easy to use - our software helps you automate tasks, boost productivity, and grow your business.</p>
            </div>
          </div>
        </div>

        {/* Products Grid Section */}
        <div className='productsview-main-section'>
          <div className='productsview-container'>
            {loading && (
              <div className='productsview-loading'>Loading products...</div>
            )}

            {error && (
              <div className='productsview-error'>{error}</div>
            )}

            {!loading && !error && products.length === 0 ? (
              <div className='productsview-no-products'>
                <p>No products available at the moment.</p>
              </div>
            ) : (
              <div className='productsview-grid'>
                {products.map(product => (
                  <ProductsviewCard key={product.id} product={product} onViewMore={handleViewMore} />
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
      
      <Footer/>
    </>
  )
}

// Updated Product Card Component
const ProductsviewCard = ({ product, onViewMore }) => {
  return (
    <div className='productsview-card'>
      <div className='productsview-card-header'>
        <h3 className='productsview-product-name'>{product.name}</h3>
        <div 
          onClick={() => onViewMore(product)} 
          className='productsview-view-more-link'
        >
          View More →
        </div>
      </div>
      
      <div className='productsview-card-body'>
        <div className='productsview-card-image'>
          {product.featured_image_url ? (
            <img 
              src={`${API_URL}/${product.featured_image_url}`}
              alt={product.name}
              onError={(e) => {
                e.target.src = '/images/placeholder-product.png';
              }}
            />
          ) : (
            <div className='productsview-image-placeholder'>
              <span>No Image</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};